import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PaymentProviderService', PaymentProviderService);

  PaymentProviderService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'moment',
    // 'PaymentProviderModalService',
    'WindowModalService',
  ];

  function PaymentProviderService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    moment,
    // PaymentProviderModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'payment_providers';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPaymentProviders: getPaymentProviders,
      getPaymentProvider: getPaymentProvider,
      savePaymentProvider: savePaymentProvider,
      deletePaymentProvider: deletePaymentProvider,
      updatePaymentProviders: updatePaymentProviders,
      searchOpenPayments: searchOpenPayments,
      openSearchOpenPayments: openSearchOpenPayments,
      openItemPaymentProviderModal: openItemPaymentProviderModal,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filterCriteria;
    }

    function getPaymentProviders(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria(); //var
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;
      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getPaymentProvider(id) {
      // if (!filterCriteria) {
      //   filterCriteria = {
      //     page: 1,
      //     sortDir: 'desc',
      //     sortedBy: 'date',
      //   };
      // }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePaymentProvider(item) {
      var itemAddedMsg = $translate('PAYMENT_PROVIDER_ADDED');
      var itemModifiedMsg = $translate('PAYMENT_PROVIDER_MODIFIED');

      var dateFormatBD = config.DATE_FORMAT_DB;
      item.date = moment(item.date).format(dateFormatBD);

      var method = 'post';
      var url = apiUrl;

      if (item.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + item.id;
      }

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { payment_provider: item }, success, failure);
    }

    function deletePaymentProvider(paymentProvider, successCallback) {
      let url = apiUrl + '/' + paymentProvider.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: paymentProvider.company_id },
        function () {
          let params = {
            title: 'SURE_TO_DELETE_PAYMENT_PROVIDER',
            body: 'DELETING_PAYMENTS_PROVIDER_WARNING',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'PAYMENT_PROVIDER_DELETED',
            company_id: paymentProvider.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function updatePaymentProviders(action, items, successCallback) {
      var params = { body: null };

      if (action === 'deactivate') {
        params.body = 'DEACTIVATING_PAYMENTS_PROVIDER_WARNING';
      } else if (action === 'destroy') {
        params.body = 'DELETING_PAYMENTS_PROVIDER_WARNING';
      }

      utils.updateItems(apiUrl, action, items, successCallback, params);
    }

    function searchOpenPayments(filterCriteria) {
      var url = apiUrl + '/search_open_documents';

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function openSearchOpenPayments(filterCriteria, paymentProviderDocuments, successCallback) {
      //PaymentProviderModalService.openSearchOpenPayments(filterCriteria, paymentProviderDocuments, successCallback);
    }

    function openItemPaymentProviderModal(paymentProvider, mode, company, item, successCallback) {
      var openPaymentProvider = function (data) {
        var templateUrl =
          './app/ajs/payment-providers/item-payment-providers/modals/item-payment-provider-detail-modal.html';

        var modalParams = {
          title: 'PAYMENT_DETAILS',
          item: data,
          mode: mode,
          preventModalClose: true,
          additionalParams: {
            company: company,
            item: item,
          },
        };

        var confirmCallback = function (response) {
          if (paymentProvider.id) {
            // Edit
            paymentProvider.payment_number = response.payment_number;
            paymentProvider.date = response.date;
            paymentProvider.reference_number = response.reference_number;
            paymentProvider.amount = response.amount;
            paymentProvider.amount_in_excess = response.amount_in_excess;
            paymentProvider.notes = response.notes;

            paymentProvider.user_id = response.user_id;
            paymentProvider.payment_method_code = response.payment_method_code;
            paymentProvider.payment_method_id = response.payment_method_id;
            paymentProvider.currency = response.currency;
            paymentProvider.currency_id = response.currency_id;
            paymentProvider.document_type_id = response.document_type_id;

            utils.itemListChanged(response.id); // response
          }

          return successCallback(response);
        };

        WindowModalService.open(templateUrl, modalParams, confirmCallback);
      };

      if (paymentProvider.id) {
        // View // Edit
        getPaymentProvider(paymentProvider.id, '').then(function (data) {
          openPaymentProvider(data);
        });
      } else {
        // Create
        openPaymentProvider(paymentProvider);
      }
    }

    function openRelatedTransactions(transaction, provider) {
      let templateUrl =
        './app/ajs/payment-providers/modals/payment-provider-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          providerId: provider.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, providerId) {
      const params = {
        skip_check_role: true,
        provider_id: providerId,
      };

      return RestResource.request(
        'get',
        `${apiUrl}/${id}/related_transaction/`,
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
